import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';
import ScoringLoader, { endpointNames } from 'general/js/loaders/scoring-loader';
import { getRoundById } from 'general/js/helpers';
import { LiveStatsCardContainer, statsTypes, getStatsCards } from 'components/live-stats';
import { BlockPlaceholder } from 'components/block-placeholder';
import { BlockSpinner } from 'components/block-spinner';

class ContextualStatsLayout extends React.Component {
    constructor(props) {
        super(props);

        const cardType = this.getType();
        const statsCards = getStatsCards();
        const filteredCards = statsCards.filter((statsCard) => statsCard.type === cardType);

        this.card = this.getRadomCard(filteredCards);
    }

    componentDidMount() {
        ScoringLoader.subscribe(endpointNames.LIVE_SCANNER);
        ScoringLoader.subscribe(endpointNames.STATISTICS);
        ScoringLoader.subscribe(endpointNames.COURSE);
    }

    componentWillUnmount() {
        ScoringLoader.unsubscribe(endpointNames.LIVE_SCANNER);
        ScoringLoader.unsubscribe(endpointNames.STATISTICS);
        ScoringLoader.unsubscribe(endpointNames.COURSE);
    }

    getRound() {
        const activeRoundId = get(this.props, 'liveScanner.activeRoundId');

        return getRoundById(this.props.scoringStats.rounds, activeRoundId);
    }

    getRandomType() {
        const statsTypesList = Object.keys(statsTypes);
        const len = statsTypesList.length;
        const randomIndex = Math.round(Math.random() * (len - 1));
        const key = statsTypesList[randomIndex];

        return statsTypes[key];
    }

    getType() {
        const { type, players, holes } = this.props.options;

        if (players.length && holes.length) {
            return this.getRandomType();
        }

        if (players.length) {
            return statsTypes.PLAYER;
        }

        if (holes.length) {
            return statsTypes.HOLE;
        }

        return type || this.getRandomType();
    }

    getRadomCard(list) {
        return list[Math.round(Math.random() * (list.length - 1))];
    }

    getSitecoreData(statsName) {
        return get(this.props.scoringStats, `sitecoreData[${statsName}]`, null);
    }

    getStats(card) {
        const { players, holes } = this.props.options;
        const round = this.getRound();
        const stats = get(round, `[${card.name}].stats`, []);

        // override state
        if (players.length || holes.length) {
            return card.type === statsTypes.PLAYER ?
                this.getStatsByIds(stats, players, 'playerId') :
                this.getStatsByIds(stats, holes, 'holeId');
        }

        return this.getTopStats(stats);
    }

    getTopStats(stats) {
        return stats.slice(0, 3);
    }

    getStatsByIds(stats, ids, idKey) {
        return ids
            .map((id) =>
                stats.find((statsModel) =>
                    statsModel[idKey].toString() === id.toString()))
            .filter((mappedStat) => mappedStat !== undefined);
    }

    generateCard() {
        const { scoringStats } = this.props;

        if (!scoringStats) return null;

        const card = cloneDeep(this.card);

        card.sitecoreData = this.getSitecoreData(card.name);
        card.stats = this.getStats(card);
        card.targetUrl = this.props.options.viewAllUrl;

        return card;
    }

    render() {
        const { liveScanner, scoringStats } = this.props;

        if (liveScanner === undefined ||
            scoringStats === undefined
        ) {
            return (
                <BlockPlaceholder minHeight={300}>
                    <BlockSpinner />
                </BlockPlaceholder>
            );
        }

        if (!liveScanner ||
            !scoringStats ||
            !Array.isArray(scoringStats.rounds)
        ) {
            return null;
        }

        const card = this.generateCard();

        return <LiveStatsCardContainer model={card} />;
    }
}

ContextualStatsLayout.propTypes = {
    options: PropTypes.object
};

const mapStateToProps = (state) => ({
    liveScanner: state.scoring[endpointNames.LIVE_SCANNER],
    scoringStats: state.scoring[endpointNames.STATISTICS],
    courseStats: state.scoring[endpointNames.COURSE],
});

const ContextualStatsLayoutContainer = connect(
    mapStateToProps,
    null
)(ContextualStatsLayout);

export default ContextualStatsLayoutContainer;
